import { render, staticRenderFns } from "./FilterBarContentTypeItem.vue?vue&type=template&id=32982977&"
import script from "./FilterBarContentTypeItem.vue?vue&type=script&lang=ts&"
export * from "./FilterBarContentTypeItem.vue?vue&type=script&lang=ts&"
import style0 from "./FilterBarContentTypeItem.vue?vue&type=style&index=0&id=32982977&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports